import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service'

@Injectable({
    providedIn: 'root'
})

export class ServiceCategoriesDataService {
    constructor(private dataProvider: DataService) {
    }
    getServiceCategories(LanguageCode:string): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetServiceCategory, LanguageCode).toPromise();
    }
    addUpdateServiceCategories(model: any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddUpdateServiceCategory, model).toPromise();
    }
    getByIdServiceCategories(id: any): Promise<any> {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetServiceCategoryById, id).toPromise();
    }
    deleteServiceCategories(id: any): Promise<any> {
        return this.dataProvider.Delete<GenericResponse<any>>(Urls.DeleteServiceCategory, id).toPromise();
    }
}